import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c78af97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base text-content" }


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceAlertPopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  content: {
    type: String,
    default: '',
  },
  isRepublish: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue', 'republish'],
  setup(__props, { emit: __emit }) {



const emit = __emit

const close = () => {
  emit('update:modelValue', false)
}

const republishDevice = () => {
  emit('republish')
  close()
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: "Something went wrong",
    open: __props.modelValue,
    onClose: close
  }, {
    footer: _withCtx(() => [
      (__props.isRepublish)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary text-base w-full",
            onClick: republishDevice
          }, " Republish "))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "btn btn-primary text-base w-full",
            onClick: close
          }, _toDisplayString(_ctx.$t('close-button')), 1))
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(__props.content), 1)
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})